/* Synouvelle Header: nach dem Scrollen wieder einblenden, sobald die Seite ruht (wie bei Dior).
   Das Ausblenden beim Scrollen nach unten übernimmt weiterhin Dawn (sticky-header), die weiche Bewegung kommt aus syn-header.css. */
(function () {
  function start() {
    var header = document.getElementById('shopify-section-header');
    if (!header || !document.querySelector('sticky-header')) return;
    var timer;
    window.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (header.classList.contains('shopify-section-header-hidden')) {
          header.classList.add('shopify-section-header-sticky');
          header.classList.remove('shopify-section-header-hidden');
        }
      }, 350);
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Warenkorb-Knopf in Karten (Dior, Mario 22.10.2026): Beim ersten Drüberfahren die volle Breite messen
   (Rand + Tasche + Abstand + Text), damit der Knopf in 0,7 s genau bis zum Textende aufgeht. */
(function () {
  document.addEventListener('pointerover', function (e) {
    var btn = e.target.closest && e.target.closest('.quick-add .quick-add__submit.button');
    if (!btn || btn.style.getPropertyValue('--syn-voll')) return;
    var text = btn.querySelector('span');
    if (!text) return;
    var cs = getComputedStyle(btn);
    var tasche = parseFloat(getComputedStyle(btn, '::before').width) || 0;
    var voll = parseFloat(cs.paddingLeft) + tasche + parseFloat(cs.columnGap || cs.gap || 0) + text.offsetWidth + parseFloat(cs.paddingRight);
    btn.style.setProperty('--syn-voll', Math.ceil(voll) + 'px');
  }, { passive: true });
})();

/* X in der Kopfleiste des Handy-Menüs (sections/header.liquid, .syn-menu-zu, Mario 22.10.2026): schließt das Menü wie der Burger.
   Dawn hängt an jeden Knopf im Menü einen Untermenü-Schließer; der räumt Seitensperre und menu-open nicht auf,
   deshalb hier das vollständige Schließen über closeMenuDrawer (wie GGs, assets/bf-header.js). */
document.addEventListener('click', function (e) {
  var zu = e.target.closest && e.target.closest('.syn-menu-zu');
  if (!zu) return;
  var drawer = zu.closest('header-drawer');
  var summary = drawer && drawer.querySelector('#Details-menu-drawer-container > summary');
  if (drawer && summary && typeof drawer.closeMenuDrawer === 'function') {
    e.preventDefault();
    drawer.closeMenuDrawer(e, summary);
  }
});
